export default {
  'support': 'Support',
  'business': 'Business',
  '14kg-dryers': 'Home Appliance',
  '2-in-1': 'Home Appliance',
  '2-into-1-grill': 'Home Appliance',
  '3multi-type': 'Home Appliance',
  '3-nto-1-smart-oven': 'Home Appliance',
  '4-doors': 'Home Appliance',
  '9kg-dryers': 'Home Appliance',
  'addwash': 'Home Appliance',
  'air-cleaners': 'Home Appliance',
  'air-conditioners': 'Home Appliance',
  'anafes': 'Home Appliance',
  'appliances': 'Home Appliance',
  'bagged': 'Home Appliance',
  'bagless': 'Home Appliance',
  'boracay': 'Home Appliance',
  'bottom-freezer': 'Home Appliance',
  'bottom-mount': 'Home Appliance',
  'bottom-mount-freezer': 'Home Appliance',
  'build-in-fridge-freezer': 'Home Appliance',
  'builtin': 'Home Appliance',
  'built-in': 'Home Appliance',
  'built-in-appliances': 'Home Appliance',
  'built-in-bottom-mount-freezer': 'Home Appliance',
  'built-in-bottom-mount-freezers': 'Home Appliance',
  'built-in-fridge-freezer': 'Home Appliance',
  'built-in-microwave-ovens': 'Home Appliance',
  'built-in-microwaves': 'Home Appliance',
  'built-in-refrigerator': 'Home Appliance',
  'built-in-refrigerators': 'Home Appliance',
  'built-under': 'Home Appliance',
  'business-vacuum-cleaner': 'Home Appliance',
  'campanas': 'Home Appliance',
  'canister': 'Home Appliance',
  'cassette-type': 'Home Appliance',
  'chef-collection': 'Home Appliance',
  'chef-collection-induction': 'Home Appliance',
  'classic-white': 'Home Appliance',
  'climate': 'Home Appliance',
  'combi': 'Home Appliance',
  'commercial': 'Home Appliance',
  'commercial-microwaves': 'Home Appliance',
  'compact': 'Home Appliance',
  'compact-oven': 'Home Appliance',
  'convection': 'Home Appliance',
  'cooking-appliance': 'Home Appliance',
  'cooking-appliances': 'Home Appliance',
  'cooktops': 'Home Appliance',
  'cooling-dvms': 'Home Appliance',
  'cooling-for-residential': 'Home Appliance',
  'cooling-single': 'Home Appliance',
  'dishwasher': 'Home Appliance',
  'dish-washer': 'Home Appliance',
  'dishwashers': 'Home Appliance',
  'dishwasher-waterfall': 'Home Appliance',
  'dishwashrs': 'Home Appliance',
  'dome': 'Home Appliance',
  'drum': 'Home Appliance',
  'dryer': 'Home Appliance',
  'dryer-accessories': 'Home Appliance',
  'dryer-indoor-kit': 'Home Appliance',
  'dryer-inside-kit': 'Home Appliance',
  'dryers': 'Home Appliance',
  'dryer-top-kit': 'Home Appliance',
  'electric': 'Home Appliance',
  'electric-oven': 'Home Appliance',
  'electric-range': 'Home Appliance',
  'electric-range-hybrid': 'Home Appliance',
  'electric-range-radiant': 'Home Appliance',
  'familyhub': 'Home Appliance',
  'family-hub': 'Home Appliance',
  'filters': 'Home Appliance',
  'flexwash': 'Home Appliance',
  'food-showcase': 'Home Appliance',
  'freestanding': 'Home Appliance',
  'frigorificos-americanos': 'Home Appliance',
  'front-load': 'Home Appliance',
  'front-loader': 'Home Appliance',
  'fully-integrated': 'Home Appliance',
  'garantieerweiterung': 'Home Appliance',
  'gas-on-glass': 'Home Appliance',
  'gas-on-metal': 'Home Appliance',
  'gold-mirror': 'Home Appliance',
  'good': 'Home Appliance',
  'grill': 'Home Appliance',
  'grill-microwave': 'Home Appliance',
  'h9000': 'Home Appliance',
  'hand-stick': 'Home Appliance',
  'heat-pump-boilers': 'Home Appliance',
  'hob': 'Home Appliance',
  'hobs': 'Home Appliance',
  'home-appliances-accessories': 'Home Appliance',
  'hood': 'Home Appliance',
  'hoods': 'Home Appliance',
  'humidifier': 'Home Appliance',
  'induction': 'Home Appliance',
  'induction-electric-range': 'Home Appliance',
  'inverter': 'Home Appliance',
  'inverter-boracay': 'Home Appliance',
  'inverter-triangle': 'Home Appliance',
  'inverter-triangle-wi-fi': 'Home Appliance',
  'kimchiplus': 'Home Appliance',
  'kimchi-refrigerators': 'Home Appliance',
  'kimchi-refrigerators-accessories': 'Home Appliance',
  'kitchen-accessories': 'Home Appliance',
  'laundry': 'Home Appliance',
  'laundry-accessories': 'Home Appliance',
  'laundry-appliances': 'Home Appliance',
  'living-accessories': 'Home Appliance',
  'microwave': 'Home Appliance',
  'microwave-built-in': 'Home Appliance',
  'microwave-oven': 'Home Appliance',
  'microwave-oven-convection': 'Home Appliance',
  'microwave-oven-grill': 'Home Appliance',
  'microwave-ovens': 'Home Appliance',
  'microwave-oven-solo': 'Home Appliance',
  'microwaves': 'Home Appliance',
  'multi-door': 'Home Appliance',
  'old-products': 'Home Appliance',
  'one-door': 'Home Appliance',
  'on-off': 'Home Appliance',
  'oven': 'Home Appliance',
  'ovens': 'Home Appliance',
  'plasma-air-purifier': 'Home Appliance',
  'powerbot': 'Home Appliance',
  'powergun': 'Home Appliance',
  'powerstick': 'Home Appliance',
  'powerstick-pro': 'Home Appliance',
  'products-2017': 'Home Appliance',
  'quickdrive': 'Home Appliance',
  'quick-drive': 'Home Appliance',
  'refrigerator': 'Home Appliance',
  'refrigerators': 'Home Appliance',
  'refrigerators-freezers': 'Home Appliance',
  'residential-heating-systems': 'Home Appliance',
  'robot': 'Home Appliance',
  'semi-automatic': 'Home Appliance',
  'semi-integrated': 'Home Appliance',
  'side-by-side': 'Home Appliance',
  'single-ovens': 'Home Appliance',
  's-inverter': 'Home Appliance',
  'small-appliances': 'Home Appliance',
  'solo': 'Home Appliance',
  'solo-microwave': 'Home Appliance',
  'split': 'Home Appliance',
  'stacking-kit': 'Home Appliance',
  'standard-dishwashers': 'Home Appliance',
  'star-wars-edition': 'Home Appliance',
  'stich-handy': 'Home Appliance',
  'stick': 'Home Appliance',
  'stick-handy': 'Home Appliance',
  'sticky-handy': 'Home Appliance',
  'system-dehumidifier': 'Home Appliance',
  'tall-solo-freezer': 'Home Appliance',
  'tall-solo-fridge': 'Home Appliance',
  'telescopic': 'Home Appliance',
  'top-mount-freezer': 'Home Appliance',
  'top-mount-refrigerator': 'Home Appliance',
  '-top-mount-refrigerator': 'Home Appliance',
  't-shaped': 'Home Appliance',
  'twin': 'Home Appliance',
  'twincooling-plus-sup-tm-sup': 'Home Appliance',
  'twin-tub': 'Home Appliance',
  'upright': 'Home Appliance',
  'upright-freezer': 'Home Appliance',
  'upright-refrigerator': 'Home Appliance',
  'vacuum-cleaners': 'Home Appliance',
  'vacuum-cleaners-accessories': 'Home Appliance',
  'ventilations': 'Home Appliance',
  'warranty-extensions': 'Home Appliance',
  'washers-dyers': 'Home Appliance',
  'washing': 'Home Appliance',
  'washing-machines': 'Home Appliance',
  'wind-free': 'Home Appliance',
  'windfree-inverter-wi-fi': 'Home Appliance',
  'wood-brown': 'Home Appliance',
  'wood-rose': 'Home Appliance',
  '860-evo': 'IT',
  '860-pro': 'IT',
  '960-evo': 'IT',
  '960-pro': 'IT',
  '970-evo': 'IT',
  '970-pro': 'IT',
  'a3-multi-function-printers': 'IT',
  'allinone': 'IT',
  'all-in-one': 'IT',
  'all-in-one-7': 'IT',
  'all-in-one-pc': 'IT',
  'artpc': 'IT',
  'art-pc': 'IT',
  'artpc-pulse': 'IT',
  'business-monitor': 'IT',
  'chromebooks': 'IT',
  'cloud-monitor': 'IT',
  'color-laser-mfp': 'IT',
  'color-lasertoner': 'IT',
  'computer': 'IT',
  'copying-paper': 'IT',
  'curved-monitor': 'IT',
  'curved-qled': 'IT',
  'dedicated-accessories': 'IT',
  'desktop': 'IT',
  'desktop-odyssey': 'IT',
  'desktop-slim': 'IT',
  'desktop-tower': 'IT',
  'digital-flipchart': 'IT',
  'digital-multifunction-printers': 'IT',
  'digital-paperboard': 'IT',
  'evo': 'IT',
  'evo-select': 'IT',
  'ex-hdd': 'IT',
  'fax': 'IT',
  'fhd-monitor': 'IT',
  'flash-discs': 'IT',
  'flat-monitor': 'IT',
  'gamer-monitor': 'IT',
  'gaming': 'IT',
  'gaming-artpc': 'IT',
  'gaming-desktop': 'IT',
  'gaming-keyboard': 'IT',
  'gaming-monitor': 'IT',
  'gaming-monitors': 'IT',
  'gaming-mouse': 'IT',
  'gaming-shop': 'IT',
  'general-multifunction-printers': 'IT',
  'genuine-infinite-inkjet': 'IT',
  'high-resolution': 'IT',
  'high-resolution-monitor': 'IT',
  'hmd': 'IT',
  'inkjet-ink': 'IT',
  'inkjet-mfp': 'IT',
  'ink-toner-copying-paper': 'IT',
  'keyboard-mouse': 'IT',
  'laser-mfp': 'IT',
  'laser-toner': 'IT',
  'memory-card': 'IT',
  'memory-cards': 'IT',
  'memory-storage': 'IT',
  'mfp': 'IT',
  'monitor': 'IT',
  'monitor-gamer': 'IT',
  'monitor-gaming': 'IT',
  'monitors': 'IT',
  'monitor-tv': 'IT',
  'network': 'IT',
  'notebook': 'IT',
  'notebook-7-spin': 'IT',
  'notebook-9-always': 'IT',
  'notebook-9-pen': 'IT',
  'notebook-9-pro': 'IT',
  'notebook-odyssey': 'IT',
  'notebook-pc': 'IT',
  'notebook-pen': 'IT',
  'odd': 'IT',
  'odyssey': 'IT',
  'optical-disc-drives': 'IT',
  'pc': 'IT',
  'pc-accessoires': 'IT',
  'pc-accessories': 'IT',
  'pc-accessories-others': 'IT',
  'photo-frame': 'IT',
  'portable-ssd': 'IT',
  'portable-ssd-t5': 'IT',
  'pouch': 'IT',
  'printer-options': 'IT',
  'printers': 'IT',
  'printers-multifunction': 'IT',
  'printer-supplies': 'IT',
  'products-it-2017': 'IT',
  'professional': 'IT',
  'qled-gaming': 'IT',
  'qled-hd': 'IT',
  'samsung-flip': 'IT',
  'ssd': 'IT',
  'store-displays': 'IT',
  'supplies': 'IT',
  'supplies-accessories': 'IT',
  't3': 'IT',
  't3-ssd': 'IT',
  't5': 'IT',
  'toc-monitor': 'IT',
  'tv-tuner': 'IT',
  'ufd': 'IT',
  'uhd-monitor': 'IT',
  'ultra-wide-curved-monitor': 'IT',
  'usb': 'IT',
  'usb-flash': 'IT',
  'usb-flash-drive': 'IT',
  'usb-flash-drives': 'IT',
  'wlan': 'IT',
  'wlan-network': 'IT',
  'wqhd': 'IT',
  'wqhd-monitor': 'IT',
  'x5': 'IT',
  '2-en-1': 'Mobile',
  '360-camera': 'Mobile',
  'activity-tracker': 'Mobile',
  'adapter': 'Mobile',
  'akg-lifestyle-headphones': 'Mobile',
  'archived-mobile-devices': 'Mobile',
  'auto': 'Mobile',
  'battery': 'Mobile',
  'connected': 'Mobile',
  'connectivity': 'Mobile',
  'dex': 'Mobile',
  'flim': 'Mobile',
  'galaxy-book': 'Mobile',
  'galaxy-c': 'Mobile',
  'galaxy-camera': 'Mobile',
  'galaxy-c-pro': 'Mobile',
  'galaxy-gear': 'Mobile',
  'galaxy-note': 'Mobile',
  'galaxy-on': 'Mobile',
  'galaxy-tab-active': 'Mobile',
  'galaxy-tab-j': 'Mobile',
  'galaxy-watch': 'Mobile',
  'gear-360': 'Mobile',
  'gear-accessories': 'Mobile',
  'gear-fit': 'Mobile',
  'gear-fit-2-pro': 'Mobile',
  'gear-iconx': 'Mobile',
  'gear-s': 'Mobile',
  'gear-sport': 'Mobile',
  'gear-s-strap': 'Mobile',
  'hub': 'Mobile',
  'hubs': 'Mobile',
  'input': 'Mobile',
  'iot': 'Mobile',
  'iot-network-device': 'Mobile',
  'jbl-home-systems': 'Mobile',
  'jbl-smart-audio': 'Mobile',
  'jbl-sport-headphones': 'Mobile',
  'jbl-wired-headphones': 'Mobile',
  'jbl-wireless-headphones': 'Mobile',
  'keyboard': 'Mobile',
  'mobile-accessories-peripheral': 'Mobile',
  'mobile-accessories': 'Mobile',
  'mobile-iot': 'Mobile',
  'mobile-office': 'Mobile',
  'mobile-phones': 'Mobile',
  'online': 'Mobile',
  'other': 'Mobile',
  'other-phones': 'Mobile',
  'power': 'Mobile',
  'products-im-2017': 'Mobile',
  'screen-protector': 'Mobile',
  'sensor': 'Mobile',
  'smapp': 'Mobile',
  'smart-home': 'Mobile',
  'smartphones': 'Mobile',
  'smartthings': 'Mobile',
  'smart-watch': 'Mobile',
  'smartwatches': 'Mobile',
  'smartwatches-and-fitness-band': 'Mobile',
  'smartwatches-fitness-bands': 'Mobile',
  'speakers': 'Mobile',
  'tablet-accessories': 'Mobile',
  'tablets': 'Mobile',
  'uk-shop': 'Mobile',
  'virtual-and-reality': 'Mobile',
  'virtual-reality': 'Mobile',
  'vr': 'Mobile',
  'watch': 'Mobile',
  'watchstrap': 'Mobile',
  'watchstraps': 'Mobile',
  'wearables': 'Mobile',
  'windows-tablet': 'Mobile',
  'windows-tablets': 'Mobile',
  'wireless-headphones': 'Mobile',
  'wirelles-and-audio': 'Mobile',
  '2017-qled-tv': 'TV & AV',
  '4k-tv': 'TV & AV',
  'akg': 'TV & AV',
  'akg-new': 'TV & AV',
  'all-in-one-soundbars': 'TV & AV',
  'all-tv-accessories': 'TV & AV',
  'archived-tv-av': 'TV & AV',
  'archived-tv-av-devices': 'TV & AV',
  'audio': 'TV & AV',
  'audio-accessories': 'TV & AV',
  'audio-systems': 'TV & AV',
  'audio-video': 'TV & AV',
  'av-accessories': 'TV & AV',
  'bluetooth-speaker': 'TV & AV',
  'blu-ray': 'TV & AV',
  'blu-ray-dvd-players': 'TV & AV',
  'blu-ray-hd': 'TV & AV',
  'blu-ray-player': 'TV & AV',
  'blu-ray-players': 'TV & AV',
  'certified-uhd-tvs': 'TV & AV',
  'cinematic-soundbars': 'TV & AV',
  'dolby-atmos-soundbar': 'TV & AV',
  'dvd': 'TV & AV',
  'ear-headset': 'TV & AV',
  'frame': 'TV & AV',
  'frametv': 'TV & AV',
  'frame-tv': 'TV & AV',
  'full-hd': 'TV & AV',
  'full-hd-and-hd-tv': 'TV & AV',
  'full-hd-hd-tv': 'TV & AV',
  'headphone': 'TV & AV',
  'head-phone': 'TV & AV',
  'home-audio': 'TV & AV',
  'home-entertainment-system': 'TV & AV',
  'home-theater': 'TV & AV',
  'in-ear': 'TV & AV',
  'jbl': 'TV & AV',
  'jbl-new': 'TV & AV',
  'lifestyletv': 'TV & AV',
  'lifestyle-tv': 'TV & AV',
  'lifestyle-tv-accessories': 'TV & AV',
  'multiroom': 'TV & AV',
  'oled-tv': 'TV & AV',
  'premium-tv': 'TV & AV',
  'premium-uhd': 'TV & AV',
  'premium-uhd-4k': 'TV & AV',
  'premium-uhd-4k-tv': 'TV & AV',
  'premium-uhd-tv': 'TV & AV',
  'products-tv-2017': 'TV & AV',
  'puhd-tv': 'TV & AV',
  'qled': 'TV & AV',
  'qled-4k-tv': 'TV & AV',
  'qled-tv': 'TV & AV',
  'qled-tvs': 'TV & AV',
  'samsung-harman-kardon-soundbars-powered-by-dolby-atmos': 'TV & AV',
  'satelite-receivers': 'TV & AV',
  'satellite-receivers': 'TV & AV',
  'serif': 'TV & AV',
  'seriftv': 'TV & AV',
  'serif-tv': 'TV & AV',
  'serif-tvs': 'TV & AV',
  'smart-audio': 'TV & AV',
  'smart-business-tv': 'TV & AV',
  'smart-hi-fi-speakers': 'TV & AV',
  'smart-signage-tv': 'TV & AV',
  'smart-speakers': 'TV & AV',
  'sound': 'TV & AV',
  'soundbar': 'TV & AV',
  'sound-bar': 'TV & AV',
  'soundbar-accessories': 'TV & AV',
  'soundbars': 'TV & AV',
  'soundbar-sound': 'TV & AV',
  'soundbar-sound-plus': 'TV & AV',
  'soundbar-soundplus': 'TV & AV',
  'soundbars-powered-by-dolby-atmos': 'TV & AV',
  'soundbars-sound': 'TV & AV',
  'soundbars-with-sub-woofers': 'TV & AV',
  'sound-for-tv': 'TV & AV',
  'sound-soundbar': 'TV & AV',
  'speaker': 'TV & AV',
  'the-frame': 'TV & AV',
  'the-frame-tv': 'TV & AV',
  'tv-accessories': 'TV & AV',
  'tv-av': 'TV & AV',
  'tv-premium-uhd': 'TV & AV',
  'tv-qled': 'TV & AV',
  'tvs': 'TV & AV',
  'tv-stand': 'TV & AV',
  'ubd-4k-player': 'TV & AV',
  'uhd-blu-ray-players': 'TV & AV',
  'uhd-premium': 'TV & AV',
  'ultra-hd-blu-ray-player': 'TV & AV',
  'wall-mount': 'TV & AV',
  'wifi-audio': 'TV & AV',
  'wireless-audio': 'TV & AV',
  'wireless-audio-with-dock': 'TV & AV',
  'zubehör': 'TV & AV'
}
